export default __webpack_public_path__ + "static/media/hectar.7bb7481b.svg";